module.exports = " <div class=row> <div class=col-lg-12> <div class=\"wrapper wrapper-content animated fadeIn\"> <div class=ibox> <div class=ibox-title> <h2 style=float:right><button ng-click=$state.forceReload()>Reload</button></h2> </div> <div class=ibox-content> Generate reports to share with investors, the team, clients or simply to use for you own personal benefit. </div> </div> </div> </div> </div> <dnit-drilldown></dnit-drilldown> <crud-denormalized-neamtime-invoiced-time-curate></crud-denormalized-neamtime-invoiced-time-curate> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/2-time/export.overview.html
// module id = 4077
// module chunks = 86